import React, { Component } from 'react';
import { Glyphicon, FormGroup, FormControl, ControlLabel, Panel, Button } from "react-bootstrap";
import UserProfile from './UserProfile';
import Input from './UI/Input/Input';
import "./TransactionOut.css";
import AlertElement from './UI/Alert/Alert';
import Utility from './Utility';
import axios from 'axios';

export class TransactionOut extends Component {
    displayName = TransactionOut.name

    constructor(props) {
        super(props);
        this.state = {
            forecasts: [],
            loading: false,
            showerror: false,
            errorheader: '',
            errortext: '',
            formsconfig:
            {
                show: false,
                type: 0,
            },
            objform: {
                id: {
                    elementType: 'hidden',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Id'
                    },
                    value: '0',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: true
                },
                dataPagamento: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'Data Pagamento'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                matricola: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Matricola'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                importoCommissione: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'number',
                        step: '.01',
                        max: '1000',
                        min: '0',
                        placeholder: 'Commissione'
                    },
                    value: '1',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                }
            },
            filterForm: {
                dateFrom: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'Da:'
                    },
                    value: Utility.todayDate(),
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                dateTo: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'A:'
                    },
                    value: Utility.todayDate(),
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                matricola: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'numeric',
                        placeholder: 'Matricola:'
                    },
                    value: '',
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
            },
            formIsValid: false,

        };
        this.filterCustom = this.filterCustom.bind(this);
        //this.refresh();
    }
    todayDate() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return yyyy + '-' + mm + '-' + dd;
    }
    formatDate(date) {
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();

        return year + '-' + monthIndex+1 + '-' + day;
    }

    refresh() {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            DateFrom: this.state.filterForm.dateFrom.value,
            DateTo: this.state.filterForm.dateTo.value,
        })
        axios.post('api/TransactionOut/List', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState({ forecasts: respose.data, loading: false });
            })
            .catch(data => {
            });
    }
    filterCustom(value) {
        //console.log('value:', value);
        //console.log('this',this.state);
        var result = true;
        result &= (this.state.filterForm.matricola === '' || value.matricola.includes(this.state.filterForm.matricola.value));
        return result;
    }
    InserisciFetch = event => {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Matricola: this.state.objform.matricola.value,
            ImportoCommissione: this.state.objform.importoCommissione.value
        });
        axios.post('api/TransactionOut/Insert', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                if (respose.data != '' && respose.data != 'OK')
                {
                    this.state.showerror = true;
                    this.state.errorheader = 'Errore inserimento:';
                    this.state.errortext = respose.data;
                }
            this.setState(prevState => {
                let updatingstate = Object.assign({}, prevState);
                updatingstate.formsconfig.show = false;
                return { updatingstate };
            })
            this.refresh();
        })
            .catch(data => {
                this.state.showerror = true;
                this.state.errorheader = 'Errore inserimento:';
                this.state.errortext = data.respose;
        });
    }
    Nuovo = event => {
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.objform.matricola.value = '';
            updatingstate.objform.dataPagamento.value = this.todayDate();
            updatingstate.objform.importoCommissione.value = '1.00'
            updatingstate.formsconfig.show = true;
            updatingstate.formsconfig.type = 1;
            return { updatingstate };
        })
    }
    Chiudi = event => {
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.formsconfig.show = false;
            return { updatingstate };
        })
    }
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }
    filterFormChangeHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.filterForm
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        if (inputIdentifier == 'dateFrom' || inputIdentifier == 'dateTo') {
            this.setState({ filterForm: updatedForm}, () => {
            //this.refresh();
            });
        } else {
            this.setState({ filterForm: updatedForm, formIsValid: formIsValid });
            //this.forceRender();
        }
    }
    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.objform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        if (inputIdentifier == 'importoCommissione')
        {
            if (updatedFormElement.value > 1000.00) { updatedFormElement.value = 1000.00; }
            if (updatedFormElement.value < 0.00) { updatedFormElement.value = 0.00 }
        }
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ objform: updatedForm, formIsValid: formIsValid });
    }
    clickdismiss() {
        this.state.showerror = false;
        this.forceRender();
    }
    forceRender = event => {
        this.setState({ time: Date.now() })
    }

    ricerca = (event) => {
        this.refresh();
        this.forceRender();
    }
    static renderTable(forecasts, modifyFunction, deleteFunction, administrator, filterCustom) {
        return (
            <table className='table' >
                <thead>
                    <tr>
                        <th>Matricola</th>
                        <th>Data Operazione</th>
                        <th>Data Pagamento</th>
                        <th>Importo Totale</th>
                        <th>Importo Bonifico</th>
                        <th>Commissioni BPAY</th>
                        <th>Commissioni Bonifico</th>
                    </tr>
                </thead>
                <tbody>
                    {forecasts.filter(filterCustom)
                            .map(forecast =>
                        <tr key={forecast.id}>
                            <td>{forecast.matricola}</td>
                            <td>{forecast.dataOperazioneStr}</td>
                            <td>{forecast.dataPagamentoStr}</td>
                            <td>{(Math.round(forecast.importoTotale * 100) / 100).toFixed(2)} EUR</td>
                            <td>{(Math.round(forecast.importoBonifico * 100) / 100).toFixed(2)} EUR</td>
                            <td>{(Math.round(forecast.commissioneBPAY * 100) / 100).toFixed(2)} EUR</td>
                            <td>{(Math.round(forecast.commissioneBonifico * 100) / 100).toFixed(2)} EUR</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {
        const formFilterElementsArray = [];
        for (let key in this.state.filterForm) {
            formFilterElementsArray.push({
                id: key,
                config: this.state.filterForm[key]
            });
        }
        let formFilter = (
            <div>
                <div className="row">
                    {formFilterElementsArray.map(formElement => (
                        <div className="col-sm-3" key={'div' + formElement.id}>
                            <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                touched={formElement.config.touched}
                                changed={(event) => this.filterFormChangeHandler(event, formElement.id)}
                                textdisabled={false} />
                        </div>
                    ))}
                </div>
            </div>
        );

        const formElementsArray = [];
        for (let key in this.state.objform) {
            formElementsArray.push({
                id: key,
                config: this.state.objform[key]
            });
        }
        let formInser = (
            <div>
                <form>
                    {formElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={true}
                            shouldValidate={true}
                            touched={true}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            textdisabled={false} />
                    ))}
                </form>
                <div className="row">
                    <div className="col-sm-6 btn-action">
                        {(this.state.formsconfig.type === 1) && <Button block bsSize="large" onClick={(event) => this.InserisciFetch(event)} type="button" className="btn btn-success btn-action">  Inserisci </Button>}
                    </div>
                    <div className="col-sm-6 btn-action">
                        <Button block bsSize="large" onClick={(event) => this.Chiudi(event)} type="button" className="btn btn-secondary btn-action">  Chiudi </Button>
                    </div>
                </div>
            </div>
        );
        let contents = this.state.loading
            ? <p class="col-sm-10"><em>Loading...</em></p>
            : TransactionOut.renderTable(this.state.forecasts, this.Modifica, this.Elimina, (UserProfile.getLogin().level===-99), this.filterCustom);

        return (
            <div>
                {(this.state.showerror == true) && <AlertElement strong={this.state.errorheader} message={this.state.errortext} clicked={(event) => this.clickdismiss(event)} />}
                <h1>Accrediti</h1>
                { formFilter }
                {(this.state.formsconfig.show === true) && formInser}
                {(this.state.formsconfig.show === false && UserProfile.getLogin().level === -99) &&
                    <Button block bsSize="large" onClick={(event) => this.Nuovo(event)} type="button" className="btn btn-success btn-action col-sm-6">  Nuova Transazione </Button>
                }
                <div className="col-sm-10">
                    <button onClick={(event) => this.ricerca(event)} type="button" className="btn btn-info">RICERCA</button>
                </div>
                <span></span>
                {contents}
            </div>
        );
    }
}
